import React, { useEffect, useState } from 'react';
import { useInstance } from '../context/InstanceContext';

interface InstanceMarkProps {
	className?: string;
}

const InstanceMark: React.FC<InstanceMarkProps> = ({ className }) => {
	const { branding, logoSrc, status } = useInstance();
	const box = className ?? 'w-9 h-9 object-contain';
	// Reste vide tant que le fichier définitif n'est pas décodé.
	// Sinon le logo par défaut s'affiche, puis est remplacé.
	const [shownSrc, setShownSrc] = useState<string | null>(null);

	useEffect(() => {
		if (status === 'loading' || !logoSrc) return;
		let cancelled = false;
		const img = new Image();
		img.onload = () => {
			if (!cancelled) setShownSrc(logoSrc);
		};
		img.onerror = () => {
			if (!cancelled) setShownSrc(logoSrc);
		};
		img.src = logoSrc;
		return () => {
			cancelled = true;
		};
	}, [status, logoSrc]);

	if (!shownSrc) {
		return <span className={`${box} inline-block`} aria-hidden="true" />;
	}

	return (
		<img
			src={shownSrc}
			alt={branding?.displayName || 'Corelys'}
			className={box}
		/>
	);
};

export default InstanceMark;
